import React from "react";

const SvgAhsLogomarkMono = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 150 148" {...props}>
      <path
        fill="currentcolor"
        d="M95.144 51.657v14.117h19.73l-.006 36.788c.002 16.757-13.484 30.393-30.24 30.577-16.755.184-30.537-13.153-30.903-29.905h-.017V80.78h.016V65.774h22.571v22.425h-17.87v14.116h32.002V44.73L45.69 0 .956 44.73v57.585h38.65v.273h.02c.044 24.64 20.034 44.59 44.674 44.583 24.64-.008 44.619-19.969 44.648-44.609V51.657H95.144zm-55.538 0v36.542H15.073V51.441L45.69 20.77v.005l30.606 30.609v.273H39.606zM144.076 64.2a5.594 5.594 0 115.61-5.61 5.555 5.555 0 01-5.61 5.61zm.031-10.63a5.037 5.037 0 104.991 5.02 4.989 4.989 0 00-4.991-5.02zm1.236 5.593l1.576 2.21h-1.329l-1.42-2.025h-1.222v2.025h-1.112v-5.857h2.61c1.36 0 2.257.696 2.257 1.87a1.748 1.748 0 01-1.36 1.777zm-.942-2.642h-1.454v1.854h1.453c.726 0 1.159-.356 1.159-.927 0-.603-.433-.927-1.159-.927z"
      />
    </svg>
  );
};

export default SvgAhsLogomarkMono;
